import store from "../../store/store";

export const componentKey = "DOCUMENTS_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setCloseCreateDocumentDialog: (state, action) => {
      state.closeCreateDocumentDialog = action.payload;
    },
    setDocumentListData: (state, action) => {
      state.documentListData = action.payload;
    },
  },
  initialReducerState: {
    closeCreateDocumentDialog: false,
    documentListData: {},
  },
});

export const { setCloseCreateDocumentDialog, setDocumentListData } = actions;
